import { vrvTypes, resetState } from '../actionTypes';

const initialState = {
    gateways: [],
    selectedGateways: [],
    idus: [],
    loadingGateways: false,
    loadingIdus: false,
    commandLoading: false,
    bulkCommandLoading: false,
    schedules: [],
    loadingSchedules: false,
};

export const vrvReducer = (state = initialState, action) => {
    switch (action.type) {
        case vrvTypes.LOAD_GATEWAYS:
            return { ...state, gateways: action.payload };
        case vrvTypes.SELECT_GATEWAY:
            return { ...state, selectedGateways: action.payload };
        case vrvTypes.LOAD_IDUS:
            return { ...state, idus: action.payload };
        case vrvTypes.SET_LOADING_GATEWAYS:
            return { ...state, loadingGateways: action.payload };
        case vrvTypes.SET_LOADING_IDUS:
            return { ...state, loadingIdus: action.payload };
        case vrvTypes.SET_COMMAND_LOADING:
            return { ...state, commandLoading: action.payload };
        case vrvTypes.SET_BULK_COMMAND_LOADING:
            return { ...state, bulkCommandLoading: action.payload };
        case vrvTypes.UPDATE_IDU:
            return {
                ...state,
                idus: state.idus.map(idu =>
                    idu.iduDeviceId === action.payload.iduDeviceId
                        ? { ...idu, latestStatus: { ...idu.latestStatus, ...action.payload.updates } }
                        : idu
                ),
            };
        case vrvTypes.LOAD_SCHEDULES:
            return { ...state, schedules: action.payload };
        case vrvTypes.ADD_SCHEDULE:
            return { ...state, schedules: [action.payload, ...state.schedules] };
        case vrvTypes.SET_LOADING_SCHEDULES:
            return { ...state, loadingSchedules: action.payload };
        case vrvTypes.DELETE_SCHEDULE:
            return { ...state, schedules: state.schedules.filter(s => s._id !== action.payload) };
        case vrvTypes.TOGGLE_SCHEDULE:
            return {
                ...state,
                schedules: state.schedules.map(s =>
                    s._id === action.payload.scheduleId ? { ...s, enabled: action.payload.enabled } : s
                ),
            };
        case vrvTypes.UPDATE_SCHEDULE:
            return {
                ...state,
                schedules: state.schedules.map(s => s._id === action.payload._id ? action.payload : s),
            };
        case vrvTypes.BULK_UPDATE_IDUS: {
            const updateMap = new Map(action.payload.map(u => [u.iduDeviceId, u.updates]));
            return {
                ...state,
                idus: state.idus.map(idu => {
                    const updates = updateMap.get(idu.iduDeviceId);
                    return updates ? { ...idu, latestStatus: { ...idu.latestStatus, ...updates } } : idu;
                }),
            };
        }
        case resetState.RESET:
            return initialState;
        default:
            return state;
    }
};
